import { helpers } from "vuelidate/lib/validators";

export const passRegex = helpers.regex("passRegex", /((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/);

export const urlRegex = helpers.regex("passRegex", /((?:https?:\/\/)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i);
